module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAABMBAMAAACMrcpQAAAAIVBMVEUAAAAApeEAo+EAntsAod4Apt8Ao+IApt0Ap+IAotwAoujHEVd6AAAAC3RSTlMAMxsHLigiEg0sFsbdITcAAACRSURBVDjLVcc7AcMgFADAJ6GF/CckICESkIAEJCAhEiK1a++2i++/1V42224HXYIme9jHFlvpGnS3H9vtpEvQZLNt9rWVbkF3e9tiJz2DJptts8MG3exhb1tspWvQy2bb7aBL0GQP+9hiK12D7vZju510CZpsts2+ttIt6G5vW+ykZ9Bks2122MBmD3vbYiv7Aa5VL6ubZRz0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/WZBankPC/sanjiao2.png
// module id = L1eS
// module chunks = 69